export default __webpack_public_path__ + "static/media/flag-cocos-island.289bbcbd.svg";